import { DashboardConfig } from '../../../common/components/dashboards/types';
import { TimeSliderTypes } from '../../../common/components/timeslider/types';
import { Languages } from '../../../constants';
import {
  getAgeFactbox,
  getAttritionFactbox,
  getDemographicsAgeChart,
  getDemographicsCustomFilterChart,
  getDemographicsFunctionChart,
  getDemographicsJobGradeChart,
  getDemographicsPositionChart,
  getDemographicsTenureChart,
  getFirstYearAttritionFactbox,
  getGenderRatioFactbox,
  getIndividualsFactbox,
  getJoinersFactbox,
  getJoinersLeaversByAgeChart,
  getJoinersLeaversOverTimeChart,
  getJoinersOverTimeWithBenchmarkChart,
  getLeaversFactbox,
  getLeaversOverTimeWithBenchmarkChart,
  getManagementRatioFactbox,
  getParentalLeaveFactbox,
  getTenureFactbox,
} from './shiphealthcare-chart-helpers';

export const ShipHealthcareDashboardChartConfig2: DashboardConfig = {
  id: 'shiphealthcare_custom_db_2',
  title: {
    [Languages.EN]: 'Monthly Group Report 2',
    [Languages.JA]: 'SHIP人材諸表®（月次報告） 2',
  },
  enabled: true,
  pages: [
    {
      pageId: '1',
      dashboardId: 'shiphealthcare_custom_db_2',
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'General Info',
        [Languages.JA]: '基本情報',
      },
      pageOptions: {
        displayOptions: {
          enabled: false,
        },
        timeOptions: {
          timeSliderEnabled: true,
          timeSliderType: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 5,
      configType: 'componentConfigs',
      components: ({ storyboardDateUtils }) => [
        getIndividualsFactbox(storyboardDateUtils),
        getGenderRatioFactbox(storyboardDateUtils),
        getAgeFactbox(storyboardDateUtils),
        getTenureFactbox(storyboardDateUtils),
        getManagementRatioFactbox(storyboardDateUtils),
        getJoinersFactbox(storyboardDateUtils),
        getLeaversFactbox(storyboardDateUtils),
        getAttritionFactbox(storyboardDateUtils),
        getFirstYearAttritionFactbox(storyboardDateUtils),
        getParentalLeaveFactbox(storyboardDateUtils),
      ],
    },
    {
      pageId: '2',
      dashboardId: 'shiphealthcare_custom_db_2',
      pageNumber: 2,
      enabled: true,
      title: {
        [Languages.EN]: 'Demographics',
        [Languages.JA]: '人員構成',
      },
      pageOptions: {
        displayOptions: {
          enabled: true,
        },
        timeOptions: {
          timeSliderEnabled: true,
          timeSliderType: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 3,
      gridRows: 2,
      configType: 'componentConfigs',
      components: ({ storyboardDateUtils }) => [
        getDemographicsCustomFilterChart(storyboardDateUtils, 1),
        getDemographicsAgeChart(storyboardDateUtils, 1),
        getDemographicsTenureChart(storyboardDateUtils, 1),
        getDemographicsFunctionChart(storyboardDateUtils, 1),
        getDemographicsPositionChart(storyboardDateUtils, 1),
        getDemographicsJobGradeChart(storyboardDateUtils, 1),
      ],
    },
    {
      pageId: '3',
      dashboardId: 'shiphealthcare_custom_db_2',
      pageNumber: 3,
      enabled: true,
      title: {
        [Languages.EN]: 'Joiners and Leavers',
        [Languages.JA]: '入社・離職',
      },
      pageOptions: {
        displayOptions: {
          enabled: true,
        },
        timeOptions: {
          timeSliderEnabled: true,
          timeSliderType: TimeSliderTypes.POINT,
        },
        filterTray: {
          enabled: true,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 8,
      gridRows: 2,
      configType: 'componentConfigs',
      components: ({ storyboardDateUtils }) => [
        getJoinersLeaversOverTimeChart(storyboardDateUtils),
        getJoinersLeaversByAgeChart(storyboardDateUtils),
        getJoinersOverTimeWithBenchmarkChart(storyboardDateUtils),
        getLeaversOverTimeWithBenchmarkChart(storyboardDateUtils),
      ],
    },
  ],
};
